<template>
  <div>
    <!-- Cartão de Senha -->
    <v-card v-if="isOpen" flat :disabled="isDisabled" :color="dialog ? 'grey lighten-4' : color"
      class="pa-0 ma-0 rounded-lg elevation-2" @click="fazerChamada">
      <v-row no-gutters align="center" class="py-2">
        <v-col cols="8" class="pa-2">
          <v-card-text :dark="isDark" class="pa-0 ma-0 text-center rounded-lg d-flex align-center justify-center"
            :class="`title ${dialog ? '' : colorText}`" style="min-height: 80px;">
            <div>
              <div class="text-caption mb-1">SENHA</div>
              <strong :class="`display-2 font-weight-bold ${dialog ? '' : colorText}`">
                {{ propriedade }}{{ codigo | formatCode }}
              </strong>
            </div>
          </v-card-text>
        </v-col>
        <v-divider vertical />
        <v-col cols="3" class="text-center">
          <v-chip :color="`${colorText} lighten-4`" class="ma-1">
            <v-icon left small>mdi-clock</v-icon>
            {{ dataChegada }}
          </v-chip>
        </v-col>
      </v-row>
    </v-card>
    <v-card v-else flat dark class="rounded-lg mb-1" :color="`${color} lighten-5`" @click="fazerChamada">
      <v-row no-gutters align="center" class="py-1">
        <v-col cols="7" class="pa-1 text-center">
          <strong :class="`display-1 font-weight-bold`">
            {{ propriedade }}{{ codigo | formatCode }}
          </strong>
        </v-col>
        <v-divider vertical />
        <v-col cols="4" class="text-center">
          <v-chip big outlined color="white" class="ma-0">
            <v-icon left x-small>mdi-clock</v-icon>
            <span class="caption">{{ dataChegada }}</span>
          </v-chip>
        </v-col>
      </v-row>
    </v-card>
    <!-- Diálogo de Atendimento -->
    <v-dialog v-model="dialog" persistent max-width="500">
      <v-card :color="color" class="rounded-lg">
        <v-card-text class="pa-4">
          <v-row no-gutters align="center">
            <v-col cols="9">
              <div class="text-overline white--text mb-1">ATENDIMENTO</div>
              <div class="display-3 font-weight-bold white--text">
                {{ mapearLetraPrioridade(myAtendimento.prioridade) }}{{ myAtendimento.codigo | formatCode }}
              </div>
            </v-col>
            <v-col cols="3" class="text-center">
              <v-icon large color="white">mdi-clock</v-icon>
              <div class="title white--text">{{ converterDate(myAtendimento.dataChegada) }}</div>
            </v-col>
          </v-row>

          <!-- Serviços -->
          <v-expand-transition>
            <div v-if="servicos && isChamar">
              <v-divider class="my-3 white"></v-divider>
              <v-card flat color="transparent" class="mb-2">
                <v-card-title class="white--text pa-0">Serviços Solicitados</v-card-title>
                <v-list color="transparent" dark>
                  <v-list-item v-for="(item, index) in servicos" :key="index" class="px-0">
                    <v-list-item-icon class="mr-2">
                      <v-icon small>mdi-check</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="py-0">
                      <v-list-item-title class="white--text">{{ item.nomeServico }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </div>
          </v-expand-transition>
        </v-card-text>

        <!-- Ações -->
        <v-card-actions class="pa-4 pt-0 justify-space-between">
          <v-btn color="white" text :disabled="btnOp" @click="naoCompareceu">
            <v-icon left>mdi-close</v-icon>
            Não Compareceu
          </v-btn>

          <div>
            <v-btn color="white" outlined class="mr-2" :disabled="emChamada" @click="clickChamar">
              <v-icon left>mdi-microphone</v-icon>
              Chamar
            </v-btn>

            <v-btn color="white" :disabled="btnOp" @click="iniciarAtendimento">
              <v-icon left>mdi-account-arrow-right</v-icon>
              Iniciar
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'CodigoFicha',
  props: {
    myAtendimento: Object,
    propriedade: String,
    codigo: String,
    dataChegada: String,
    servicos: Array,
    tipo: Number,
    btnOp: {
      type: Boolean,
      default: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    emChamada: Boolean,
    myDisabled: {
      type: Boolean,
      default: false
    },
    isDark: {
      type: Boolean,
      default: false
    },
    markColor: {
      type: String,
      default: 'grey lighten-3'
    },
    color: {
      type: String,
      default: 'primary'
    },
    colorText: {
      type: String,
      default: 'white--text'
    },
    mDialog: {
      type: Number,
      default: 1
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    formatCode (value) {
      return value ? value.toString().padStart(3, '0') : '000'
    }
  },
  data () {
    return {
      isChamar: false,
      dialog: false
    }
  },
  watch: {
    markColor (val) {
      this.color = val
    },
    mDialog (val) {
      this.dialog = false
    }
  },
  methods: {
    iniciarAtendimento () {
      this.$emit('iniciarAtendimento', true)
      this.dialog = false
    },
    naoCompareceu () {
      this.$emit('naoCompareceu', true)
      this.dialog = false
    },
    clickChamar () {
      this.$emit('chamar', '')
    },
    fazerChamada () {
      this.isChamar = true
      this.dialog = true
      if (this.tipo == 1) {
        this.$emit('add-atendimento')
      }
    },
    mapearLetraPrioridade (prioridade) {
      const priorityMap = {
        0: 'C',
        1: 'P',
        2: 'B',
        3: 'A'
      }
      return priorityMap[prioridade] || 'C'
    },
    converterDate (data) {
      if (!data) return '--:--'
      const d = new Date(data)
      return `${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`
    }
  }
}
</script>

<style scoped>
.v-card {
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.v-card:hover:not(.v-card--disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.display-2 {
  letter-spacing: 1px;
}

.v-divider {
  opacity: 0.5;
}
</style>
